import { Button } from '@strata/react-buttons';
import { InlineMessage } from '@strata/react-inline-message';
import PropTypes from 'prop-types';

export const PrescriberDeactivatedBanner = ({
    npi,
    message,
    onReactivate,
    isReactivating = false,
    showReactivate = true,
}) => (
    <div className="padding__bottom--small">
        <InlineMessage
            intent={InlineMessage.Intent.WARNING}
            label={
                <>
                    <p className="margin__bottom--xsmall">
                        <strong>This prescriber is deactivated.</strong>
                    </p>
                    <p className="margin__bottom--xsmall">
                        NPI {npi} is not available for referral assignment or editing.
                        {message && message !== 'Prescriber NPI is deactivated.' && <> {message}</>}
                    </p>
                    {showReactivate && (
                        <Button
                            className="margin__top--small"
                            label="Reactivate Prescriber"
                            intent={Button.Intent.PRIMARY}
                            onClick={onReactivate}
                            disabled={isReactivating}
                        />
                    )}
                </>
            }
        />
    </div>
);

PrescriberDeactivatedBanner.propTypes = {
    npi: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    onReactivate: PropTypes.func.isRequired,
    isReactivating: PropTypes.bool,
    showReactivate: PropTypes.bool,
};
